import { ErrorBoundary } from 'react-error-boundary'
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom'

import ErrorFallback from '~/components/errorFallback'
import SignoutContextProvider from '~/features/auth/components/signoutContextProvider'
import routes from '~/pages/routes'

const router = createBrowserRouter([
  {
    element: (
      // Above ErrorBoundary so ErrorFallback can call useSignOut (needs context).
      <SignoutContextProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onError={(error, info) => {
            /* eslint-disable no-console */
            console.error('=== Error Message ===')
            console.error(error.message)
            console.error('=== Error Stack ===')
            console.error(error.stack)
            console.error('=== Error Component Stack ===')
            console.error(info.componentStack)
            console.error(
              '=== Before reporting the error, please also check the following ===',
            )
            console.error(
              '1. Open the network tab and screenshot the detailed request that failed',
            )
            console.error(
              '2. Open the application tab and screenshot the detailed view of local storage and session storage',
            )
          }}
        >
          <Outlet />
        </ErrorBoundary>
      </SignoutContextProvider>
    ),
    children: routes,
  },
])

export function Router() {
  return (
    <RouterProvider
      future={{
        v7_startTransition: true,
      }}
      router={router}
    />
  )
}

export default Router
